import { render, staticRenderFns } from "./area.vue?vue&type=template&id=4f39003a&scoped=true&"
import script from "./area.vue?vue&type=script&lang=js&"
export * from "./area.vue?vue&type=script&lang=js&"
import style0 from "./area.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./area.vue?vue&type=style&index=1&id=4f39003a&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f39003a",
  null
  
)

export default component.exports